// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';

/**
 * @class Jsw.Box
 * Component with custom inner html.
 * @extends Jsw.Component
 *
 * Example usage:
 *
 *     @example
 *     new Jsw.Box({
 *         renderTo: document.body,
 *         html: '<h1>Heading 1</h1><p>Paragraph</p>'
 *     });
 */
export const Box = Class.create(Component, {
    _tag: 'div',

    /**
     * @cfg {String} html Inner html of the box.
     */

    _initComponentElement($super) {
        $super();

        this._componentElement.update(
            this._getConfigParam('html', '')
        );
    },
});



// WEBPACK FOOTER //
// ./jsw/box.js